import { css } from "@emotion/css"

export const styles = {
  inputRoot: css`
    svg {
      width: 18px;
      height: 24px;
    }
  `,
  option: css`
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 8px;
    &:hover {
      background-color: var(--primary-light);
    }
  `,
  closeIcon: css`
    width: 18px !important;
    height: 18px !important;
    background-color: var(--dark-grey);
    color: var(--white);
    border-radius: 50%;
    cursor: pointer;
  `,
  indicator: css`
    .MuiIconButton-root {
      color: var(--white);
    }
  `,
  disabled: css`
    &.MuiOutlinedInput-root {
      .Mui-disabled {
        color: #aeb5bc;
      }
    }

    &.Mui-disabled {
      .MuiOutlinedInput-notchedOutline {
        border: solid 1px #aeb5bc;
        background-color: var(--extra-dark-grey2);
      }
    }
  `,
}
